const hi = {
  // Navigation
  'nav.dashboard': 'डैशबोर्ड',
  'nav.algorithms': 'एल्गोरिदम',
  'nav.charts': 'चार्ट',
  'nav.brokers': 'ब्रोकर',
  'nav.tradingHistory': 'ट्रेडिंग इतिहास',
  'nav.paperTrading': 'पेपर ट्रेडिंग',
  'nav.portfolio': 'पोर्टफोलियो',
  'nav.settings': 'सेटिंग्स',
  'nav.screener': 'स्क्रीनर',
  'nav.marketplace': 'मार्केटप्लेस',
  'nav.journal': 'जर्नल',

  // Common actions
  'action.save': 'सहेजें',
  'action.cancel': 'रद्द करें',
  'action.delete': 'हटाएं',
  'action.edit': 'संपादित करें',
  'action.create': 'बनाएं',
  'action.start': 'शुरू करें',
  'action.stop': 'रोकें',
  'action.refresh': 'रिफ्रेश',
  'action.export': 'निर्यात',
  'action.import': 'आयात',
  'action.search': 'खोजें',
  'action.filter': 'फ़िल्टर',
  'action.back': 'वापस',
  'action.next': 'अगला',
  'action.confirm': 'पुष्टि करें',
  'action.close': 'बंद करें',

  // Trading terms
  'trading.buy': 'खरीदें',
  'trading.sell': 'बेचें',
  'trading.long': 'लॉन्ग',
  'trading.short': 'शॉर्ट',
  'trading.profit': 'लाभ',
  'trading.loss': 'हानि',
  'trading.pnl': 'लाभ/हानि',
  'trading.winRate': 'जीत दर',
  'trading.totalTrades': 'कुल ट्रेड',
  'trading.openPositions': 'खुली पोजीशन',
  'trading.balance': 'शेष राशि',
  'trading.symbol': 'सिंबल',
  'trading.quantity': 'मात्रा',
  'trading.price': 'कीमत',
  'trading.entryPrice': 'प्रवेश कीमत',
  'trading.exitPrice': 'निकास कीमत',
  'trading.stopLoss': 'स्टॉप लॉस',
  'trading.takeProfit': 'टेक प्रॉफिट',
  'trading.status': 'स्थिति',

  // Status labels
  'status.active': 'सक्रिय',
  'status.paused': 'रुका हुआ',
  'status.stopped': 'बंद',
  'status.draft': 'ड्राफ्ट',
  'status.completed': 'पूर्ण',
  'status.running': 'चल रहा है',
  'status.failed': 'विफल',
  'status.pending': 'लंबित',

  // Dashboard
  'dashboard.title': 'डैशबोर्ड',
  'dashboard.todayPnl': 'आज का लाभ/हानि',
  'dashboard.totalBalance': 'कुल शेष',
  'dashboard.activeAlgorithms': 'सक्रिय एल्गोरिदम',
  'dashboard.recentTrades': 'हाल के ट्रेड',

  // Settings
  'settings.title': 'सेटिंग्स',
  'settings.language': 'भाषा',
  'settings.theme': 'थीम',
  'settings.notifications': 'सूचनाएं',

  // Empty states
  'empty.noAlgorithms': 'अभी कोई एल्गोरिदम नहीं',
  'empty.noTrades': 'अभी कोई ट्रेड नहीं',
  'empty.noData': 'कोई डेटा उपलब्ध नहीं'
}

export default hi
